// extracted by mini-css-extract-plugin
export default {"graphicPromoCard":"GraphicPromoCard_graphicPromoCard__Njg4Y","emptyCard":"GraphicPromoCard_emptyCard__NTE1O"};